
import Select from 'react-select'
import React, { useEffect, useState } from 'react'
import Header from '../../../../../../Components/Header/Header'
import Sidebar from '../../../../../../Components/Sidebar/Sidebar'
import DeletePopup from '../../../GardenPopup/DeletePopup'
import { useSearchParams } from 'react-router-dom'
import moment from 'moment'
import { WardNameDataDDL } from '../../../../../../Components/CommonDDL/WardNameDataDDL'
import { useDispatch, useSelector } from 'react-redux'
import { STPQualityTableDataAPI, STPQualityTableExportDataAPI } from '../../../../../../Redux/STPDashboardSlice/STPPreventiveWork/STPQualitySlice'
import { useAuthState } from '../../../../../../Helper/Context'
import { Loading } from '../../../../../../Helper/Loading'
import STPPreventiveSewerageQuality_B_Data from './STPPreventiveSewerageQuality_B_Data'
import { STPPreventiveSewerageQuality_A_ExportData } from './STPPreventiveSewerageQuality_A_DataExport'
import { STPPreventiveSewerageQuality_B_ExportData } from './STPPreventiveSewerageQuality_B_DataExport'
import STPSeweragePreventiveQualityWardWise_A_Data from './STPSewerageQualityWardWiseScreenChange/STPSewerageQualityWardWiseScreenChangeForA'
import STPPreventiveSewerageQualityWardWise_B_Data from './STPSewerageQualityWardWiseScreenChange/ATPSewerageQualityWardWiseScreenForQualityParamater_B'


export default function STPPreventiveSewerageQualityData() {

    const userDetails = useAuthState();
    const { UserID, token, } = userDetails.user

    const [DeletePopupShow, setDeletePopupShow] = useState()
    const [STPEquipmentMasterPopupShow, setSTPEquipmentMasterPopupShow] = useState()
    const [rowData, setrowData] = useState('')
    const [isSearch, setIsSearch] = useState(false)
    const [IsPost, setIsPost] = useState(false)
    const [To, setTo] = useState(10)
    const [IsClear, setIsClear] = useState(false)
    const [FromDate, setFromDate] = useState(moment().startOf('month').format('YYYY-MM-DD'))
    const [ToDate, setToDate] = useState(moment().format('YYYY-MM-DD'))

    const [searchParams] = useSearchParams()
    let HYear = searchParams.get("Year")
    let YLable = searchParams.get("YLable")
    let HMonth = searchParams.get("Month")
    let MLable = searchParams.get("MLable")
    let HWard = searchParams.get("WardName")
    let WLable = searchParams.get("WLable")
    let ProjectTypeId = searchParams.get("ProjectTypeId")
    let DashboardName = searchParams.get("DashboardName")
    let QualityType = searchParams.get("Quality")


    const [WardName, setWardName] = useState({
        DDL: [],
        ID: HWard && HWard ? HWard : '0',
        Label: WLable && WLable ? WLable : "Select...",
    })

    const ParameterData = [
        {
            value: 'Sewerage_A',
            label: 'Quality A'
        },
        {
            value: 'Sewerage_B',
            label: 'Quality B'
        }

    ]
    const [ParameterType, setParameterType] = useState({
        DDL: ParameterData,
        ID: QualityType == 'A' ? ParameterData[0].value : ParameterData[1].value,
        Label: QualityType == 'A' ? ParameterData[0].label : ParameterData[1].label,
    })

    const dispatch = useDispatch()

    useEffect(() => {
        const data = {
            FromDate: FromDate,
            ToDate: ToDate,
            M_WardID: WardName.ID,
            M_UserID: UserID,
            token: token,
            ReportType: ParameterType.ID == 'Sewerage_A' ? 'Sewerage_A' : 'Sewerage_B',
            STPQualityExport: STPQualityExport
        }
        dispatch(STPQualityTableDataAPI({ data }))
    }, [FromDate, ToDate, isSearch, IsPost, To, WardName.ID, ParameterType.ID, IsClear])

    const { tableData, isLoading } = useSelector(state => state.STPQualityTableData)

    const STPQualityExport = () => {
        const data = {
            FromDate: FromDate,
            ToDate: ToDate,
            M_WardID: WardName.ID,
            M_UserID: UserID,
            token: token,
            ReportType: ParameterType.ID == 'Sewerage_A' ? 'Sewerage_A' : 'Sewerage_B'
        }
        dispatch(STPQualityTableExportDataAPI({ data }))
    }
    // [FromDate, ToDate, isSearch, IsPost, WardName.ID, ParameterType.ID, IsClear,]

    const { ExportTableData, isExportLoading } = useSelector(state => state.STPQualityTableExportData)

    const handleSearch = () => {
        setIsSearch(!isSearch)
    }

    const handleClear = () => {
        setIsClear(!IsClear)
        setWardName({
            ...WardName,
            ID: HWard,
            Label: WLable,
        })
        setParameterType({
            ...ParameterType,
            ID: ParameterData[0].value,
            Label: ParameterData[0].label,
        })
        setFromDate(moment().startOf('month').format('YYYY-MM-DD'))
        setToDate(moment().format('YYYY-MM-DD'))
    }

    // console.log('ParameterData', ParameterType , ExportTableData)
    return (
        <div>
            {isLoading && <Loading />}
            <Header
                MLable={MLable}
                HMonth={HMonth}
                YLable={YLable}
                HYear={HYear}
                HWard={HWard}
                WLable={WLable}
                flag='Screen'
                DashboardName={DashboardName}
            />
            <div className="wrapper">
                <Sidebar ProjectTypeId={ProjectTypeId} />
                <div className="content">
                    <div className='data_mob'>
                        <div className="row m-1 pb-4 master_border">
                            <div className='mt-2'>
                                <h5>Sewerage Quality</h5>
                                <div className="float-end butt">
                                    {
                                        isExportLoading || isLoading ?
                                            <button type="button" className="btn btn-primary float-end mr-1 mb-1 ml-1" disabled>
                                                <i
                                                    className="fa fa-refresh fa-spin"
                                                    style={{ marginRight: "5px" }}
                                                />Loading</button>
                                            :
                                            tableData && tableData.length > 0 &&
                                            <>
                                                {
                                                    ParameterType.Label == 'Quality A' ?
                                                        <STPPreventiveSewerageQuality_A_ExportData
                                                            ExcelData={ExportTableData}
                                                            name='Sewerage Quality A'
                                                            FromDate={FromDate}
                                                            ToDate={ToDate}
                                                        // searchName={searchName}
                                                        />
                                                        :
                                                        <STPPreventiveSewerageQuality_B_ExportData
                                                            ExcelData={ExportTableData}
                                                            name='Sewerage Quality B'
                                                            FromDate={FromDate}
                                                            ToDate={ToDate}
                                                        // searchName={searchName}
                                                        />
                                                }

                                            </>
                                    }
                                </div>
                            </div>
                            <div className="row m-0 pt-1">
                                <div className="col-12 py-0 rounded rounded-2 shadow"
                                    style={{ border: "1px solid #00000024", background: "#27466317" }}>
                                    <div className="col-12">

                                        <div className="row py-1 rounded2">

                                            <div className="col-lg-2 col-md-2">
                                                <label for=""><b>From Date </b></label>
                                                <input type="date"
                                                    className="form-control"
                                                    id="FromDate"
                                                    value={FromDate}
                                                    onChange={(e) => (setFromDate(e.target.value), setToDate(''))}
                                                />

                                            </div>

                                            <div className="col-lg-2 col-md-2">
                                                <label for=""><b>To Date </b></label>
                                                <input type="date"
                                                    className="form-control"
                                                    id="ToDate"
                                                    value={ToDate}
                                                    onChange={(e) => setToDate(e.target.value)}
                                                    min={FromDate}
                                                />

                                            </div>


                                            <div className="col-lg-2 col-md-4">
                                                <WardNameDataDDL
                                                    WardName={WardName}
                                                    setWardName={setWardName}
                                                    HWard={HWard}
                                                    WLable={WLable}
                                                // Flag='ward'
                                                />

                                            </div>

                                            <div className="col-lg-3 col-md-4">
                                                <label for=""><b>Parameter Type </b></label>
                                                <Select
                                                    // isClearable
                                                    // isRtl={isRtl}
                                                    // className="ddl_width"
                                                    isSearchable
                                                    maxMenuHeight={150}
                                                    value={{ value: ParameterType.ID, label: ParameterType.Label }}
                                                    onChange={(e) => {
                                                        e ?
                                                            setParameterType({ ...ParameterType, ID: e.value, Label: e.label })
                                                            :
                                                            setParameterType({ ...ParameterType, ID: 0, Label: "Select..." })

                                                    }}
                                                    options={ParameterType.DDL}
                                                />

                                            </div>

                                            <div className="col-12 col-lg-3 col-md-4 mt-lg-4 mt-md-2 mt-2 d-md-flex " >
                                                {/* <button type="button"
                                                    className="btn-clear btn btn-primary mx-2"
                                                    onClick={handleSearch}
                                                >
                                                    Search</button> */}
                                                <button type="button"
                                                    className="btn btn-outline-danger"
                                                    onClick={handleClear}
                                                >
                                                    Clear</button>
                                            </div>

                                        </div>
                                        {
                                            WardName.ID == 22 && ParameterType.ID == 'Sewerage_A' ?
                                                <>
                                                    <STPSeweragePreventiveQualityWardWise_A_Data
                                                        tableData={tableData}
                                                    // open={DeletePopupShow}
                                                    />
                                                </>
                                                :
                                                WardName.ID == 22 && ParameterType.ID == 'Sewerage_B' ?
                                                    <>
                                                        <STPPreventiveSewerageQualityWardWise_B_Data
                                                            tableData={tableData}
                                                        // open={DeletePopupShow}
                                                        />
                                                    </>
                                                    :
                                                    <>
                                                        {
                                                            ParameterType.ID == 'Sewerage_A' ?
                                                                <>
                                                                    <div className="row mob_table table-responsive pt-1" style={{height:'60vh'}}>

                                                                        <table id="totalordergenerated"
                                                                            cellPadding="0"
                                                                            cellSpacing="0"
                                                                            border="0"
                                                                            className="table table-bordered">

                                                                            <thead>
                                                                                <tr>
                                                                                    <th rowSpan="2" className="sr_no_col">Sr No.</th>
                                                                                    <th rowSpan="2">Date</th>
                                                                                    <th colSpan="2" className='new_grid'>BOD (Mg / L)</th>
                                                                                    <th colSpan="2" className='new_grid'>COD (Mg / L)</th>
                                                                                    <th colSpan="2" className='new_grid'>DO (Mg / L)</th>
                                                                                    <th colSpan="2" className='new_grid'>Flow (MLD)</th>
                                                                                    <th colSpan="2" className='new_grid'>PH</th>
                                                                                    <th colSpan="2" className='new_grid'>TDS (Mg / L)</th>
                                                                                    <th colSpan="2" className='new_grid'>Temperature (°C)</th>
                                                                                    {/* <th rowSpan="2" className='action_icon'>Action</th> */}
                                                                                </tr>
                                                                                <tr>
                                                                                    <th>inlet</th>
                                                                                    <th>outlet</th>
                                                                                    <th>inlet</th>
                                                                                    <th>outlet</th>
                                                                                    <th>inlet</th>
                                                                                    <th>outlet</th>
                                                                                    <th>inlet</th>
                                                                                    <th>outlet</th>
                                                                                    <th>inlet</th>
                                                                                    <th>outlet</th>
                                                                                    <th>inlet</th>
                                                                                    <th>outlet</th>
                                                                                    <th>inlet</th>
                                                                                    <th>outlet</th>
                                                                                </tr>
                                                                            </thead>

                                                                            <tbody>
                                                                                {/* {console.log('cxv xcv', tableData)} */}
                                                                                {
                                                                                    tableData && tableData.length > 0 ? tableData.map((item) => (
                                                                                        <tr>
                                                                                            <td style={{ textAlign: "center" }}>{item.srNo ? item.srNo : '-'}</td>
                                                                                            <td>{item.readingDate ? item.readingDate : '-'}</td>
                                                                                            <td>{item.boD_Mg_L_Inlet ? item.boD_Mg_L_Inlet : '0'}</td>
                                                                                            <td>{item.boD_Mg_L_Outlet ? item.boD_Mg_L_Outlet : '0'}</td>
                                                                                            <td>{item.coD_Mg_L_Inlet ? item.coD_Mg_L_Inlet : '0'}</td>
                                                                                            <td>{item.coD_Mg_L_Outlet ? item.coD_Mg_L_Outlet : '0'}</td>
                                                                                            <td>{item.dO_Mg_L_Inlet ? item.dO_Mg_L_Inlet : '0'}</td>
                                                                                            <td>{item.dO_Mg_L_Outlet ? item.dO_Mg_L_Outlet : '0'}</td>
                                                                                            <td>{item.flow_MLD_Inlet ? item.flow_MLD_Inlet : '0'}</td>
                                                                                            <td>{item.flow_MLD_Outlet ? item.flow_MLD_Outlet : '0'}</td>
                                                                                            <td>{item.pH_Inlet ? item.pH_Inlet : '0'}</td>
                                                                                            <td>{item.pH_Outlet ? item.pH_Outlet : '0'}</td>
                                                                                            <td>{item.tdS_Mg_L_Inlet ? item.tdS_Mg_L_Inlet : '0'}</td>
                                                                                            <td>{item.tdS_Mg_L_Outlet ? item.tdS_Mg_L_Outlet : '0'}</td>
                                                                                            <td>{item.temperature_C_Inlet ? item.temperature_C_Inlet : '0'}</td>
                                                                                            <td>{item.temperature_C_Outlet ? item.temperature_C_Outlet : '0'}</td>
                                                                                        </tr>
                                                                                    ))
                                                                                        :
                                                                                        <></>
                                                                                }
                                                                            </tbody>
                                                                        </table>

                                                                    </div>
                                                                </>
                                                                :
                                                                ParameterType.ID == 'Sewerage_B' ?
                                                                    <>
                                                                        <STPPreventiveSewerageQuality_B_Data
                                                                            tableData={tableData}
                                                                            open={DeletePopupShow}
                                                                        />
                                                                    </>
                                                                    :
                                                                    ''
                                                        }
                                                    </>
                                        }


                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>



    )
}